import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M8 16C10.1217 16 12.1563 15.1569 13.6568 13.6568C15.1568 12.1562 16 10.1217 16 8C16 5.87833 15.1569 3.84367 13.6568 2.34317C12.1562 0.843167 10.1217 0 8 0C5.87833 0 3.84367 0.8431 2.34317 2.34317C0.843167 3.84382 0 5.87833 0 8C0 10.1217 0.8431 12.1563 2.34317 13.6568C3.84382 15.1568 5.87833 16 8 16Z",
      fill: "#687588"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M8 3.75C7.44792 3.75 7 4.19792 7 4.75V8.25C7 8.80208 7.44792 9.25 8 9.25C8.55208 9.25 9 8.80208 9 8.25V4.75C9 4.19792 8.55208 3.75 8 3.75ZM8.92383 10.8672C8.76888 10.4935 8.4043 10.25 8 10.25C7.44792 10.25 7 10.6979 7 11.25C7 11.6543 7.24348 12.0189 7.61718 12.1738C7.99088 12.3288 8.42123 12.2428 8.70703 11.957C8.99284 11.6712 9.07878 11.2409 8.92383 10.8672Z",
      fill: "white"
    }, null, -1)
  ]))]))
}